import { Translate } from 'react-admin';

export function formatErrorMessage(errorMessage: string, translate: Translate): string {
  const messages = errorMessage.split(';').map(msg => translate(msg.trim()));
  const formattedMessage = messages.join('\n');

  return formattedMessage;
}
